import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const Sitemap = () => {
  const pages = [
    { url: '/', title: 'Home - FLUMBERICO: World\'s First SEO Link Juice Token', priority: 'High' },
    { url: '/whitepaper', title: 'Whitepaper - SEO Equity Tokenization Explained', priority: 'High' },
    { url: '/how-to-earn', title: 'How to Earn $FLUMBERICO Tokens', priority: 'High' },
    { url: '/chart', title: 'Live Price Chart', priority: 'Medium' },
    { url: '/blog', title: 'Blog - SEO & Link Building Insights', priority: 'High' },
    { url: '/about', title: 'About FLUMBERICO', priority: 'Medium' },
    { url: '/contact', title: 'Contact Us', priority: 'Medium' },
    { url: '/terms', title: 'Terms of Service', priority: 'Low' },
    { url: '/privacy', title: 'Privacy Policy', priority: 'Low' },
    { url: '/risk-warning', title: 'Risk Warning', priority: 'Low' },
  ];

  const blogPosts = [
    { slug: 'seo-equity-tokenization', title: 'SEO Equity & The World\'s First Tokenization of Link Juice' },
    { slug: 'domain-authority-explained', title: 'Domain Authority Explained: The Currency of the Internet' },
    { slug: 'link-building-strategies-2025', title: 'Link Building Strategies for 2025: What Works Now' },
    { slug: 'what-is-link-juice', title: 'What is Link Juice? Understanding SEO\'s Most Valuable Asset' },
    { slug: 'high-authority-backlinks', title: 'How to Build High-Authority Backlinks That Actually Work' },
    { slug: 'domain-rating-guide', title: 'Domain Rating (DR) Complete Guide: What It Is & How to Increase It' },
    { slug: 'white-hat-link-building', title: 'White Hat Link Building: Ethical Strategies That Work in 2025' },
    { slug: 'check-domain-authority', title: 'How to Check Domain Authority: 5 Best Tools Compared' },
    { slug: 'link-juice-distribution', title: 'Link Juice Distribution: How to Maximize SEO Value Flow' },
    { slug: 'guest-posting-backlinks', title: 'Guest Posting for Backlinks: The Complete Strategy Guide' },
    { slug: 'da-vs-dr-difference', title: 'DA vs DR: Key Differences & Which Metric Matters More' },
    { slug: 'future-of-seo', title: 'The Future of SEO: Predictions for 2025 and Beyond' },
    { slug: 'ranking-success-case-study', title: 'Ranking Success Case Study: How We Hit #2 for FLUMBERICO' },
    { slug: 'technical-seo-checklist-meme-coins', title: 'Technical SEO Checklist for Meme Coins: Rank Higher Fast' },
    { slug: 'social-signals-seo-power', title: 'Social Signals & SEO Power: Leveraging Social Media for Rankings' },
    { slug: 'viral-seo-campaign-lessons', title: 'Viral SEO Campaign Lessons: What Worked & What Didn\'t' },
    { slug: 'blockchain-seo-evolution', title: 'Blockchain SEO Evolution: How Crypto Changed Search Marketing' },
  ];

  return (
    <div className="min-h-screen bg-black text-white pt-32 pb-20">
      <Helmet>
        <title>HTML Sitemap - All FLUMBERICO Pages | $FLUMBERICO</title>
        <meta name="description" content="Complete sitemap of all FLUMBERICO pages including blog posts, guides, and resources about SEO tokenization and link juice." />
        <link rel="canonical" href="https://www.flumberico.fun/sitemap" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black text-gold mb-6">
            FLUMBERICO Sitemap
          </h1>
          <p className="text-xl text-silver max-w-3xl mx-auto">
            Browse all pages on flumberico.fun - the world's first SEO link juice token. 
            Find guides, resources, and information about ranking for "flumberico" on Google.
          </p>
        </div>

        {/* Main Pages */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gold mb-8 border-b border-gold/30 pb-4">
            Main Pages
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {pages.map((page) => (
              <Link
                key={page.url}
                to={page.url}
                className="group bg-gradient-to-br from-gold/10 to-black border border-gold/30 rounded-lg p-6 hover:border-gold/60 transition-all hover:scale-105"
              >
                <div className="flex items-start justify-between mb-2">
                  <h3 className="text-lg font-bold text-white group-hover:text-gold transition-colors">
                    {page.title}
                  </h3>
                  <span className={`text-xs px-2 py-1 rounded ${
                    page.priority === 'High' ? 'bg-gold text-black' :
                    page.priority === 'Medium' ? 'bg-silver text-black' :
                    'bg-gold/20 text-gold'
                  }`}>
                    {page.priority}
                  </span>
                </div>
                <p className="text-sm text-silver group-hover:text-white transition-colors">
                  flumberico.fun{page.url}
                </p>
              </Link>
            ))}
          </div>
        </section>

        {/* Blog Posts */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gold mb-8 border-b border-gold/30 pb-4">
            SEO & Link Building Blog
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {blogPosts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group bg-gradient-to-br from-silver/10 to-black border border-silver/30 rounded-lg p-6 hover:border-gold/60 transition-all hover:scale-[1.02]"
              >
                <h3 className="text-base font-semibold text-white group-hover:text-gold transition-colors mb-2">
                  {post.title}
                </h3>
                <p className="text-sm text-silver/70 group-hover:text-silver transition-colors">
                  flumberico.fun/blog/{post.slug}
                </p>
              </Link>
            ))}
          </div>
        </section>

        {/* SEO Info */}
        <section className="bg-gradient-to-br from-gold/20 via-gold/10 to-black border-2 border-gold/50 rounded-lg p-8 text-center">
          <h2 className="text-2xl font-bold text-gold mb-4">
            About FLUMBERICO
          </h2>
          <p className="text-white text-lg leading-relaxed max-w-4xl mx-auto mb-6">
            FLUMBERICO is the world's first tokenization of SEO link juice. We're building the ultimate 
            SEO social experiment where participants compete to rank #1 for the keyword "flumberico" 
            on Google and earn $FLUMBERICO cryptocurrency tokens for building high-quality backlinks 
            to flumberico.fun. Ranking is Banking!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/" className="bg-gold text-black px-6 py-3 rounded-full font-bold hover:bg-white transition-colors">
              Learn More
            </Link>
            <Link to="/how-to-earn" className="bg-silver text-black px-6 py-3 rounded-full font-bold hover:bg-white transition-colors">
              Start Earning
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Sitemap;
